import { render, staticRenderFns } from "./OpenCasesTable.vue?vue&type=template&id=7222b15f&scoped=true&"
import script from "./OpenCasesTable.vue?vue&type=script&lang=ts&"
export * from "./OpenCasesTable.vue?vue&type=script&lang=ts&"
import style0 from "./OpenCasesTable.vue?vue&type=style&index=0&id=7222b15f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7222b15f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7222b15f', component.options)
    } else {
      api.reload('7222b15f', component.options)
    }
    module.hot.accept("./OpenCasesTable.vue?vue&type=template&id=7222b15f&scoped=true&", function () {
      api.rerender('7222b15f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/views/Customer/Cases/Open/components/OpenCasesTable.vue"
export default component.exports